import { render } from "./independentsProfilePage.vue?vue&type=template&id=20f4bf40&scoped=true"
import script from "./independentsProfilePage.vue?vue&type=script&lang=js"
export * from "./independentsProfilePage.vue?vue&type=script&lang=js"

import "./independentsProfilePage.vue?vue&type=style&index=0&id=20f4bf40&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20f4bf40"]])

export default __exports__